import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Link from 'shopper/components/Link';
import Text from 'shopper/components/Text';

const BreadcrumbItem = ({ children, href, passHref, ...rest }) =>
  href ? (
    <NextLink href={href} passHref={passHref} prefetch={false}>
      <Link size="size2" whiteSpace="nowrap" {...rest}>
        {children}
      </Link>
    </NextLink>
  ) : (
    <Text size="size2" whiteSpace="nowrap">
      {children}
    </Text>
  );

BreadcrumbItem.defaultProps = {
  href: null,
  passHref: true,
};

BreadcrumbItem.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  passHref: PropTypes.bool,
};

export default BreadcrumbItem;
